import IMapServiceConfig from '../../types/IMapServiceConfig';
import IMarker from '../../types/marker/IMarker';

const setZoom = <T extends IMarker>({ mapRef }: IMapServiceConfig<T>, value: number = 1): void => {
  const actualZoom: number = mapRef.value.$mapObject.zoom + value;

  if (actualZoom < 0) return;

  mapRef.value.$mapObject.setZoom(actualZoom);
};
export default setZoom;
